var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_vm._v("UNITY QA VIEWER (BETA)"),_c('iframe',{attrs:{"src":_vm.src,"width":"100%","height":"710","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }